
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    VIEW_CEREBRUMX_INTEGRATION_REQUEST,
    VIEW_CEREBRUMX_INTEGRATION_OPEN_MODAL,
    VIEW_CEREBRUMX_INTEGRATION_SAVE_PROFILE_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { viewCerebrumXGetIntegrationResult, viewCerebrumXSaveProfileResult } from 'Redux/actions';


function* saveCerebrumXProfile({ payload }) {
    try {
        let { companyIntegrationId, fleetId, spdLimit, harshBrakeRateLimit, rapidAccRateLimit, sharpTurnsRateLimit, idlingDurationLimit } = payload
        let QUERY = `
            mutation updateFleet($companyIntegrationId: Int!, $fleetId: Int!, $spdLimit: Int, $harshBrakeRateLimit: Float, $rapidAccRateLimit: Float, $sharpTurnsRateLimit: Float, $idlingDurationLimit: Int) {
                response: updateFleet (companyIntegrationId: $companyIntegrationId, fleetId: $fleetId, spdLimit: $spdLimit, harshBrakeRateLimit: $harshBrakeRateLimit, rapidAccRateLimit: $rapidAccRateLimit, sharpTurnsRateLimit: $sharpTurnsRateLimit, idlingDurationLimit: $idlingDurationLimit){
                    id
                    spdLimit
                    harshBrakeRateLimit
                    rapidAccRateLimit
                    sharpTurnsRateLimit
                    idlingDurationLimit
                    failureReason
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                companyIntegrationId,
                fleetId,
                spdLimit, 
                harshBrakeRateLimit, 
                rapidAccRateLimit, 
                sharpTurnsRateLimit, 
                idlingDurationLimit
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(viewCerebrumXSaveProfileResult({ result: data?.response }))

    } catch (exc) {
        yield put(viewCerebrumXSaveProfileResult({ error: exc }))
        ExceptionManager(
            exc,
            "Modules/accounts/.components/viewCerebrumXIntegration/redux/saga",
            "saveCerebrumXProfile",
        )
    }
}

function* getCompanyIntegration({ payload }) {
    try {
        const { companyIntegrationId } = payload;
        let QUERY = `
                query getCompanyIntegration ($id: Int!) {
                    result: getCompanyIntegration (id: $id) {
                        id
                        integrationId
                        integration {
                            id
                            code
                            name
                            description
                        }
                        parameters
                        externalId
                        status
                        createdBy
                        createdOn
                        updatedBy
                        updatedOn
                    }
                }
            `

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: companyIntegrationId
            },
            endpoints.GRAPHQL_GENERAL,
        );

        let formated = JSON.parse(JSON.stringify(data?.result))

        if (formated?.parameters)
            formated.parameters = JSON.parse(formated.parameters)

        QUERY = `
            query getFleetStatus($fleetId: Int!) {
                result: getFleetStatus(fleetId: $fleetId) {
                        fleetId
                        name
                        fleetStatus
                        fanId
                        oems {
                            name
                            consentStatus
                        }
                        thresholds {
                            spdLimit
                            harshBrakeRateLimit
                            rapidAccRateLimit
                            sharpTurnsRateLimit
                            idlingDurationLimit
                        }
                    }
                }
        `

        data = yield call(
            clientQuery,
            QUERY,
            {
                fleetId: formated.parameters.fleetId
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(viewCerebrumXGetIntegrationResult({ companyIntegration: formated, fleet: data?.result }))

    } catch (exc) {
        ExceptionManager(exc, 'Modules/accounts/.components/viewCerebrumXIntegration/redux/saga', 'getCompanyIntegration');
    }
}

function* watchMethods() {
    yield takeEvery(VIEW_CEREBRUMX_INTEGRATION_OPEN_MODAL, getCompanyIntegration);
    yield takeEvery(VIEW_CEREBRUMX_INTEGRATION_REQUEST, getCompanyIntegration);
    yield takeEvery(VIEW_CEREBRUMX_INTEGRATION_SAVE_PROFILE_REQUEST, saveCerebrumXProfile);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}